import { FaRegComment, FaComment } from "react-icons/fa";
import { AiOutlineLike, AiFillLike } from "react-icons/ai";
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import AddComment from "./AddComment";
import Comments from "./Comments";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useFirebase } from "../Context/FirebaseContext";
import { FEATURED_IMAGE } from "../Public/constants";
import { formatDistanceToNow } from "date-fns";

const Details = ({
  published,
  updated,
  el,
  user,
  id,
  likes,
  setShow,
  like,
  show,
  comments,
  setComments,
}) => {
  const navigate = useNavigate();
  const firebase = useFirebase();
  const [heroUrl, setHeroUrl] = useState(null);
  const [imgLoading, setImgLoading] = useState(true);

  useEffect(() => {
    if (el?.featuredImage?.includes("upload")) {
      firebase.getImageUrl(el?.featuredImage).then((url) => {
        setHeroUrl(url);
        setImgLoading(false);
      });
    } else {
      setHeroUrl(FEATURED_IMAGE);
      setImgLoading(false);
    }
  }, [el?.featuredImage, firebase]);

  const isAuthor = user?.user?.email === el?.user?.email;

  return (
    <article className="min-h-screen bg-[#f4f4f4] dark:bg-[#0a0a0a] text-black dark:text-white pb-32 pt-24 mt-[73px] font-sans selection:bg-black dark:selection:bg-white selection:text-white dark:selection:text-black">
      {/* Header Section */}
      <header className="max-w-6xl mx-auto px-4 md:px-8 mb-12 mt-8">
        <div className="border-b-4 border-black dark:border-white/30 pb-8 mb-8">
          <div className="flex flex-wrap gap-2 mb-6 justify-start">
            <span className="inline-block border border-black dark:border-white/30 px-3 py-1 text-[10px] font-mono font-bold tracking-widest uppercase bg-black dark:bg-white text-white dark:text-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
              SYS.DOC.01 — Article
            </span>
            {el.categories?.map((c, idx) => (
              <span
                key={idx}
                className="px-3 py-1 text-[10px] font-mono font-bold uppercase tracking-widest text-black dark:text-white bg-white dark:bg-black border border-black dark:border-white/30"
              >
                {c.name}
              </span>
            ))}
          </div>

          <h1 className="text-5xl md:text-6xl font-black uppercase tracking-tighter leading-[0.9] text-black dark:text-white mb-12 overflow-hidden break-words">
            {el.title}
          </h1>

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <div className="flex items-center gap-4 bg-white dark:bg-black border border-black dark:border-white/30 p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)]">
              <img
                alt={el.user?.name || "author"}
                src={el.user?.avatar}
                className="w-14 h-14 rounded-none object-cover border border-black dark:border-white/30 grayscale filter"
              />
              <div className="flex flex-col">
                <span className="font-mono font-black text-black dark:text-white text-sm uppercase tracking-widest leading-none mb-1">
                  {el.user.name}
                </span>
                <span className="text-[10px] uppercase font-mono tracking-widest text-gray-700 dark:text-gray-400 font-bold border-t border-dashed border-gray-400 dark:border-gray-600 pt-1 mt-1">
                  PUBLISHED:{" "}
                  {published.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}
                </span>
                <span className="text-[10px] uppercase font-mono tracking-widest text-gray-700 dark:text-gray-400 font-bold border-t border-dashed border-gray-400 dark:border-gray-600 pt-1 mt-1">
                  LAST UPDATED:{" "}
                  {formatDistanceToNow(updated, { addSuffix: true })}
                </span>
              </div>
            </div>

            {isAuthor && (
              <div className="flex gap-3">
                <button
                  onClick={() => navigate(`/blogs/${id}/edit`)}
                  className="flex items-center gap-2 px-6 py-3 text-[10px] font-mono font-bold tracking-widest uppercase text-black dark:text-white bg-white dark:bg-black border border-black dark:border-white/30 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] active:shadow-[0_0_0_0_rgba(0,0,0,1)] dark:active:shadow-none active:translate-x-1 active:translate-y-1"
                >
                  <FiEdit3 className="text-sm" /> Update
                </button>
                <button
                  onClick={() =>
                    navigate(`/blogs/${id}/delete`, { replace: true })
                  }
                  className="flex items-center gap-2 px-6 py-3 text-[10px] font-mono font-bold tracking-widest uppercase text-white dark:text-black bg-red-600 dark:bg-red-500 border border-black dark:border-white/30 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] active:shadow-[0_0_0_0_rgba(0,0,0,1)] dark:active:shadow-none active:translate-x-1 active:translate-y-1"
                >
                  <FiTrash2 className="text-sm" /> Terminate
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Hero Image */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 mb-16">
        <div className="w-full aspect-video md:aspect-[21/9] rounded-none border-2 border-black dark:border-white/30 overflow-hidden shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)] bg-white dark:bg-[#111] relative">
          <div className="absolute top-0 left-0 bg-black dark:bg-white text-white dark:text-black font-mono text-[10px] font-bold px-2 py-1 tracking-widest z-10 border-b border-r border-black dark:border-white/30 uppercase shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)]">
            FIG. 01 — VISUAL DATA
          </div>
          {imgLoading ? (
            <div className="w-full h-full bg-gray-200 dark:bg-gray-800 animate-pulse pattern-boxes pattern-gray-300 dark:pattern-gray-700 pattern-bg-white dark:pattern-bg-gray-900 pattern-size-4 opacity-50"></div>
          ) : (
            <img
              src={heroUrl}
              alt="Hero"
              className="w-full h-full object-cover filter grayscale hover:grayscale-0 transition-all duration-700"
            />
          )}
        </div>
      </div>

      {/* Body Content */}
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="bg-white dark:bg-[#0a0a0a] border-2 border-black dark:border-white/30 p-8 md:p-16 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)]">
          <div className="prose prose-lg dark:prose-invert max-w-none prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tight prose-p:font-mono prose-p:text-sm prose-p:font-medium prose-p:leading-relaxed prose-a:text-black dark:prose-a:text-white prose-a:font-bold prose-a:underline prose-img:border prose-img:border-black dark:prose-img:border-white prose-img:grayscale hover:prose-img:grayscale-0 prose-img:transition-all prose-blockquote:border-l-4 prose-blockquote:border-black dark:prose-blockquote:border-white prose-blockquote:bg-gray-100 dark:prose-blockquote:bg-gray-900 prose-blockquote:py-2 prose-blockquote:font-mono prose-blockquote:text-sm prose-blockquote:font-bold prose-blockquote:uppercase mx-auto">
            {el.body ? parse(el.body) : <p>NO CONTENT FOUND IN DATABANK.</p>}
          </div>

          {/* Interaction Bar */}
          <div className="mt-16 pt-8 border-t-2 border-black dark:border-white/30 flex flex-col sm:flex-row items-center justify-between gap-4 font-mono">
            <div className="text-[10px] font-bold tracking-widest uppercase text-gray-500 dark:text-gray-400">
              END OF RECORD.
            </div>
            <div className="flex items-center gap-4">
              <button
                onClick={() => like()}
                className="flex items-center gap-3 px-4 py-2 border border-black dark:border-white/30 bg-white dark:bg-black text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none dark:active:shadow-none active:translate-x-0.5 active:translate-y-0.5"
              >
                {likes.filter((l) => l.user?._id === user?.user?._id).length ? (
                  <AiFillLike className="text-xl" />
                ) : (
                  <AiOutlineLike className="text-xl" />
                )}
                <span className="text-xs font-bold uppercase tracking-widest">
                  {likes.length} Acknowledge
                </span>
              </button>

              <button
                onClick={() => setShow(!show)}
                className="flex items-center gap-3 px-4 py-2 border border-black dark:border-white/30 bg-white dark:bg-black text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-[2px_2px_0px_0px_rgba(255,255,255,0.5)] active:shadow-none dark:active:shadow-none active:translate-x-0.5 active:translate-y-0.5"
              >
                {show ? (
                  <FaComment className="text-lg" />
                ) : (
                  <FaRegComment className="text-lg" />
                )}
                <span className="text-xs font-bold uppercase tracking-widest">
                  {comments.length} Appendices
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Comments Section */}
        {show && (
          <div className="mt-16 border-t-4 border-black dark:border-white/30 pt-12">
            <h3 className="text-4xl font-black uppercase tracking-tighter leading-none text-black dark:text-white mb-8">
              APPENDICES ({comments.length})
            </h3>
            <div className="border border-black dark:border-white/30 bg-white dark:bg-[#0a0a0a] p-6 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] dark:shadow-[8px_8px_0px_0px_rgba(255,255,255,0.5)] mb-12">
              <AddComment id={id} setComments={setComments} />
            </div>

            <div className="mt-8">
              <Comments id={id} setComments={setComments} />
            </div>
          </div>
        )}
      </div>
    </article>
  );
};

export default Details;
